import { useContext } from 'react';

import { SelectChangeEvent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { observer } from 'mobx-react-lite';

import { lookupsStoreCtx } from '../../../../stores/lookups';
import { ItemType } from '../../../../types';
import { isPending } from '../../../../utils/common';
import PriorityLabel from '../../../Piority';

interface PriorityEditorType {
  id: number | string;
  value: ItemType;
  field: string;
}

export const PriorityEditor = observer(
  ({ id, value, field }: PriorityEditorType) => {
    const apiRef = useGridApiContext();
    const { activitiesPriority, activitiesPriorityLookupReq } =
      useContext(lookupsStoreCtx);

    const changeCellHandler = (fieldName: string, cellValue: ItemType) => {
      return apiRef.current.setEditCellValue({
        id,
        field: fieldName,
        value: cellValue,
      });
    };

    const handleChange = async (_event: SelectChangeEvent, child?: any) => {
      const newType = activitiesPriority.find(
        ({ id }) => id === child?.props.value,
      );
      if (!newType) {
        // eslint-disable-next-line no-console
        console.warn('Priority not found');
        return;
      }
      await changeCellHandler(field, newType);
    };

    return (
      <Select
        value={String(value?.id)}
        fullWidth
        onChange={handleChange}
        endAdornment={
          <>
            {isPending(activitiesPriorityLookupReq) ? (
              <CircularProgress color="inherit" size={20} />
            ) : null}
          </>
        }>
        {activitiesPriority?.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            <PriorityLabel
              sx={{
                justifyContent: 'flex-start',
              }}
              priority={{ id, name }}
            />
          </MenuItem>
        ))}
      </Select>
    );
  },
);

export default PriorityEditor;
